module.exports = __webpack_public_path__ + "img/check-mark-success.b1c2d36c.gif";